module.exports = __webpack_public_path__ + "static/media/video-image.ccc2d2b1.jpg";